import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Monitor, Smartphone, RotateCcw, Pencil } from "lucide-react";
import { useApi, Loading, ErrorNote } from "../../components/kit";
import PreviewPlayer from "../../components/PreviewPlayer";

const seg = (on) => `tap inline-flex items-center gap-2 rounded-md px-3 text-sm font-semibold ${on ? "bg-[color:var(--ink)] text-white" : "hover:bg-muted"}`;

export default function CoursePreview() {
  const { cid } = useParams();
  const { data, loading, error } = useApi(`/courses/${cid}`);
  const [device, setDevice] = useState("desktop");
  const [which, setWhich] = useState("draft");
  const [run, setRun] = useState(0);
  if (loading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const has = { draft: !!data.draft, published: !!data.published };
  const w = has[which] ? which : has.draft ? "draft" : "published";
  const v = w === "draft" ? data.draft : data.published;
  return (
    <div>
      <div className="sm:sticky top-16 z-20 -mx-4 mb-6 flex flex-wrap items-center gap-3 border-b bg-amber-50/95 px-4 py-3 backdrop-blur sm:-mx-8 sm:px-8" data-testid="preview-toolbar">
        <Link to={`/admin/courses/${cid}`} className="inline-flex items-center gap-1 text-sm font-semibold" data-testid="preview-back"><ArrowLeft className="h-4 w-4" /> Editor</Link>
        <span className="text-sm font-semibold text-amber-900" data-testid="preview-banner">Learner preview · {w === "draft" ? "draft" : "published"} v{v.version} · nothing is recorded</span>
        <div className="ml-auto flex flex-wrap items-center gap-2">
          {has.draft && has.published && (
            <div className="flex rounded-lg border bg-white p-1" role="group" aria-label="Version">
              <button className={seg(w === "draft")} onClick={() => setWhich("draft")} data-testid="preview-version-draft">Draft v{data.draft.version}</button>
              <button className={seg(w === "published")} onClick={() => setWhich("published")} data-testid="preview-version-published">Live v{data.published.version}</button>
            </div>)}
          <div className="flex rounded-lg border bg-white p-1" role="group" aria-label="Device">
            <button className={seg(device === "desktop")} onClick={() => setDevice("desktop")} data-testid="preview-device-desktop"><Monitor className="h-4 w-4" /> Desktop</button>
            <button className={seg(device === "phone")} onClick={() => setDevice("phone")} data-testid="preview-device-phone"><Smartphone className="h-4 w-4" /> Phone</button>
          </div>
          <button className="tap inline-flex items-center gap-2 rounded-lg border bg-white px-3 text-sm font-semibold" onClick={() => setRun(run + 1)} data-testid="preview-restart"><RotateCcw className="h-4 w-4" /> Restart</button>
          {w === "draft" && <Link to={`/admin/courses/${cid}`} className="tap inline-flex items-center gap-2 rounded-lg border bg-white px-3 text-sm font-semibold"><Pencil className="h-4 w-4" /> Edit</Link>}
        </div>
      </div>
      {device === "desktop" ? <PreviewPlayer key={`${w}-${run}`} cid={cid} which={w} /> : (
        <div className="flex justify-center">
          <div className="rounded-[2.75rem] border-[10px] border-[color:var(--ink)] bg-[color:var(--ink)] shadow-xl" data-testid="preview-phone-frame">
            <iframe key={`${w}-${run}`} title="Phone preview" src={`/preview-frame/${cid}?v=${w}`} className="block h-[780px] w-[390px] rounded-[2rem] bg-white" />
          </div>
        </div>
      )}
    </div>
  );
}
